import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Pencil } from 'lucide-react';
import { format } from 'date-fns';
import './ReviewPage.css';
import { CreateJobReq } from '@diditusa/shared/types/jobTypes';
import { useCreateJobMutation } from '@diditusa/shared/api/jobsApi';
import { useGetProductQuery } from '@diditusa/shared/api/productsApi';
import { DateTime } from 'luxon';

const ReviewPage: React.FC = () => {
  const [reviewDetails, setReviewDetails] = useState<any>(null);
  const [description, setDescription] = useState(''); // <-- Added
  const [createJob, createJobState] = useCreateJobMutation();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const productId = params.get('productId');
  const parsedProductId = productId ? parseInt(productId, 10) : NaN;

  const { data: product, ...getProductState } = useGetProductQuery(parsedProductId, {
    skip: isNaN(parsedProductId),
  });

  useEffect(() => {
    const saved = sessionStorage.getItem('reviewData');
    if (saved) {
      const parsed = JSON.parse(saved);
      setReviewDetails({ ...parsed, productId });
      setDescription(parsed.description || ''); // initialize input with saved value
    } else {
      navigate('/'); // fallback if session expired
    }
  }, [navigate, productId]);

  useEffect(() => {
    if (createJobState.data) {
      navigate(`/checkout/${createJobState.data.id}`);
    }
  }, [createJobState.data, navigate]);

  const onBackClick = () => navigate('/home');

  const onConfirmAndPayClick = () => {
    if (!productId || !product || !reviewDetails) return;

    const { pickupHour, pickupMinute, pickupAmPm, pickupDate, pickupAddress } = reviewDetails;
    let hour = parseInt(pickupHour);
    if (pickupAmPm === 'PM' && hour !== 12) hour += 12;
    if (pickupAmPm === 'AM' && hour === 12) hour = 0;
    const minute = parseInt(pickupMinute);
    const [month, day, year] = pickupDate.split('/').map(Number);

    // Create a date for 1:00 PM PST on today’s date
    const pstDate = DateTime.fromObject(
      { year, month: month, day, hour, minute },
      { zone: 'America/Los_Angeles' },
    );

    // Convert to JS Date (if needed)
    const startTime = pstDate.toJSDate();

    const jobReq: CreateJobReq = {
      description: description || 'No additional details provided.',
      durationHours: 5,
      location: pickupAddress,
      startTime,
      securityOptionId: parseInt(productId, 10),
      securityOptionPricingId: product.pricing.id,
    };

    createJob(jobReq);
  };

  const format12Hour = (h: string, m: string, ampm: 'AM' | 'PM') => `${h}:${m} ${ampm}`;
  if (!reviewDetails) return <p>Loading...</p>;

  const { tierName, pickupAddress, pickupDate, pickupHour, pickupMinute, pickupAmPm } =
    reviewDetails;

  return (
    <div className='review-container'>
      <div className='review-header'>
        <h2 className='order-form-title'>Review Your Order</h2>
        <button className='edit-button' onClick={onBackClick} title='Edit'>
          <Pencil size={30} />
        </button>
      </div>
      <div className='review-section'>
        <p>
          <strong>Service Option:</strong> {tierName}
        </p>
        <p>
          <strong>Pick Up Location:</strong> {pickupAddress}
        </p>
        <p>
          <strong>Date:</strong> {format(pickupDate, 'MM/dd/yyyy')}
        </p>
        <p>
          <strong>Time:</strong> {format12Hour(pickupHour, pickupMinute, pickupAmPm)} Las Vegas
          Local Time
        </p>
        <p>
          <strong>Duration:</strong> 5 hours
        </p>

        <div className='form-group'>
          <label>
            <strong></strong>
          </label>
          <input
            type='text'
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            className='input-field'
            placeholder='Additional details'
          />
        </div>
      </div>
      <div className='button-group'>
        <button onClick={onConfirmAndPayClick} className='submit-button'>
          Confirm & Pay
        </button>
      </div>
    </div>
  );
};

export default ReviewPage;
